module.exports = __webpack_public_path__ + "img/blog-cover.1ec6657f.png";